import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';

/**
 * Personalised, presenter-defined agenda page.
 * Rendered between the Hero and the Disclaimer when the current user
 * has configured at least one agenda item.
 */
export default function SectionAgenda({ items = [] }) {
  const { lang } = useT();
  if (!items || items.length === 0) return null;

  const AGENDA_STRINGS = {
    de: { overline: 'Programm', title: 'Agenda', sub: 'Was wir heute gemeinsam durchgehen.' },
    tr: { overline: 'Program', title: 'Gündem', sub: 'Bugün birlikte inceleyeceklerimiz.' },
    hu: { overline: 'Program', title: 'Napirend', sub: 'Amit ma közösen áttekintünk.' },
    en: { overline: 'Programme', title: 'Agenda', sub: 'What we will walk through today.' },
  };
  const strings = AGENDA_STRINGS[lang] || AGENDA_STRINGS.en;

  return (
    <SectionShell id="agenda">
      <div className="text-center mb-8 md:mb-12">
        <Reveal>
          <div className="overline mb-4">{strings.overline}</div>
          <h2 className="font-display tracking-tight leading-none text-white/95">
            {strings.title}
          </h2>
          <p className="font-ui text-white/60 text-xl md:text-2xl leading-relaxed mt-5 mx-auto max-w-[46ch]">
            {strings.sub}
          </p>
        </Reveal>
      </div>

      <Reveal delay={140}>
        <ol className="agenda-slide agenda-slide--full" data-testid="agenda-slide">
          {items.map((it, i) => (
            <li key={i} className="agenda-slide-row" data-testid={`agenda-slide-row-${i}`}>
              <span className="agenda-slide-num font-display">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="agenda-slide-rule" aria-hidden />
              <span className="agenda-slide-text font-display">{it}</span>
            </li>
          ))}
        </ol>
      </Reveal>
    </SectionShell>
  );
}
